import { render } from "./IconInstagram.vue?vue&type=template&id=9de1c4a4"
const script = {}

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__